module.exports = __webpack_public_path__ + "img/editors.2e4885b8.png";